import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import { ChangeEvent, useEffect, useState } from 'react'
import NumberFormat from 'react-number-format'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { HeaderBar } from '../../component'
import { MESSAGE_TYPE } from '../../constants'
import { InitialPaymentObjectives } from '../../constants/initialPaymentObjectives'
import { PaymentDetail } from '../../constants/paymentDetail'
import { RoundNumber } from '../../helpers/Number'
import { DocumentModel } from '../../models/document'
import { DocumentDetailModel } from '../../models/documentDetail'
import { PaymentObjectiveModel } from '../../models/paymentObjective'
import * as editActions from '../../redux/actions/transaction.edit.action'
import { RootReducers } from '../../redux/reducers'
import { EmailModal } from './emailModalForm'
import { SMSModal } from './smsModalForm'
import './style.css'

import doneCreate from '../../assets/images/done-create.svg'
import errorAlert from '../../assets/images/error-alert.svg'
import { BranchList } from '../../component/branchList'
import { EtrDetail } from '../../component/etrDetail'
import { SearchPolicyModal } from '../../component/modaldialog/SearchPolicy'
import {
  getBillingFrequency,
  hideCashPayment,
  isMaskingData,
  maskingEmail,
  maskingMobileNo
} from '../../helpers/texthelper'
import { isDisablePaymentObject } from '../../helpers/validations'
import { AgentModel } from '../../models/agent'
import * as policyDetailActions from '../../redux/actions/policy.detail.action'
import { Cheque } from './MoneyType/cheque'
import { CreditCard } from './MoneyType/creditCard'
import { OtherPay } from './MoneyType/otherPay'
import { getPaymentDetailAmount } from './helper'
import {
  handleCheckPaymentDetail,
  validateCheckboxDetailField,
  validateCheckboxObjectField,
  validateMonthCreditCard
} from './validation'

dayjs.extend(isSameOrBefore)

export const EntryForm: React.VFC = () => {
  const MAX_CASH_VAL = 100000
  const withValueCash = (inputObj: { value: any }) => {
    const { value } = inputObj
    if (value <= MAX_CASH_VAL) return true
    return false
  }

  const dispatch = useDispatch()
  const [documentData, setDocumentData] = useState<DocumentModel>({})
  const [displayDetail, setDisplayDetail] = useState<boolean>(false)
  const loginState = useSelector((state: RootReducers) => state.loginReducer)
  const [agentInfo, setAgentInfo] = useState<any>(loginState.account?.agentInfo)
  const [isOpenEmailModal, setIsOpenEmailModal] = useState<boolean>(false)
  const [isOpenSMSModal, setIsOpenSMSModal] = useState<boolean>(false)
  const navigate = useNavigate()
  const [isOpenSearchModal, setisOpenSearchModal] = useState(false)
  const [policyInfo, setPolicyInfo] = useState({
    payerName: '',
    insuredName: '',
    policyNo: '',
    paymentFrequency: '',
    planName: '',
    sumassuredAmount: 0,
    customerMail: '',
    customerPhone: '',
    customerDOB: undefined,
    displaycustomerMail: '',
    displaycustomerPhone: '',
    saveCustomerMail: '',
    saveCustomerPhone: '',
    emailstatus: 0,
    SMSstatus: 0,
    autoDisplay: false,
    isServiceAgent: false,
    serviceAgent: '',
    productGroup: '',
    SystemName: ''
  })
  const [paymentObjectives, setPaymentObjectives] =
    useState<PaymentObjectiveModel[]>(InitialPaymentObjectives)
  const [paymentDetail, setPaymentDetail] = useState<DocumentDetailModel[]>(PaymentDetail)
  const [formErrors, setFormErrors] = useState<any>({})

  useEffect(() => {
    const amountPaymentDetail = RoundNumber(calPaymentDetail())
    const amountPaymentObjective = RoundNumber(calPaymentObjective())
    console.log(
      `amountPaymentDetail = ${amountPaymentDetail}, amountPaymentObjective = ${amountPaymentObjective}`
    )
    if (
      amountPaymentDetail === amountPaymentObjective &&
      amountPaymentDetail > 0 &&
      amountPaymentObjective > 0
    ) {
      setFormErrors({ ...formErrors, amount: false })
    }
  }, [paymentObjectives, paymentDetail])

  const calPaymentObjective = () => {
    let totalPaymentObj = 0
    paymentObjectives.forEach(item => {
      if (item.isCheck) totalPaymentObj += item.amount
    })
    return totalPaymentObj
  }

  const calPaymentDetail = () => {
    let totalPaymentDetail = 0
    paymentDetail.forEach(item => {
      if (item.isCheck) totalPaymentDetail += item.paymentAmount
    })
    return totalPaymentDetail
  }

  const checkNonNBCase = () => {
    return paymentObjectives.some(
      item =>
        item.paymentObjectiveType.id !== 1 && item.paymentObjectiveType.id !== 2 && item.isCheck
    )
  }

  const validateField = () => {
    const amountPaymentDetail = RoundNumber(calPaymentDetail())
    const amountPaymentObjective = RoundNumber(calPaymentObjective())
    const checkbox =
      paymentObjectives.some(item => item.isCheck) && paymentDetail.some(item => item.isCheck)
    const amount =
      amountPaymentDetail === amountPaymentObjective &&
      amountPaymentDetail > 0 &&
      amountPaymentObjective > 0
    const correctFormatEmail = agentInfo?.email.match(
      /^([a-zA-Z0-9._%+-]+)@([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,})$/
    )
    const error: any = {}

    const checkboxDetailField = validateCheckboxDetailField(error, paymentDetail)
    const checkboxObjectField = validateCheckboxObjectField(error, paymentObjectives)

    if (
      agentInfo?.branchName &&
      agentInfo?.email &&
      correctFormatEmail &&
      policyInfo.payerName &&
      policyInfo.insuredName &&
      (!checkNonNBCase() || policyInfo.policyNo) &&
      amount &&
      checkbox &&
      checkboxDetailField &&
      checkboxObjectField
    ) {
      setFormErrors({})

      return true
    }

    if (!agentInfo?.branchName) {
      error.branchName = true
    }
    if (!agentInfo?.email || !correctFormatEmail) {
      error.email = true
    }
    if (!policyInfo?.payerName) {
      error.payerName = true
    }
    if (!policyInfo?.insuredName) {
      error.insuredName = true
    }
    if (!policyInfo?.policyNo && checkNonNBCase()) {
      error.policyNo = true
    }
    if (
      amountPaymentDetail !== amountPaymentObjective ||
      (amountPaymentDetail <= 0 && amountPaymentObjective <= 0)
    ) {
      error.amount = true
    }
    setFormErrors(error)

    return false
  }

  const onChangeAgentInfo = (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { value } = e.target
    setFormErrors({ ...formErrors, [e.target.name]: false })

    if (e.target.name === 'email') {
      setAgentInfo({ ...agentInfo, [e.target.name]: value.replaceAll(/[ก-ฮะ-์]/g, '') })
    } else setAgentInfo({ ...agentInfo, [e.target.name]: value })
  }

  const onChangePolicyInfo = (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const isPolicyNoField = e.target.name === 'policyNo'
    if (isPolicyNoField) {
      setPaymentDetail(PaymentDetail)
    }

    let { value } = e.target
    setFormErrors({ ...formErrors, [e.target.name]: false })

    if (e.target.name === 'sumassuredAmount') {
      value = value.trim().replaceAll(/,/g, '')
      value = value === '' ? '0' : value
    } else if (isPolicyNoField) {
      value = value.toUpperCase()
    }

    setPolicyInfo({
      ...policyInfo,
      [e.target.name]: value
    })
  }

  const handleWatDatePickerChange = (christDate: any, buddhistDate: any) => {
    setPolicyInfo({
      ...policyInfo,
      customerDOB: christDate
    })
  }

  const handleCheckObjective = (checkboxName: string) => {
    const updateCheckState = paymentObjectives.map(item =>
      item.name === checkboxName ? { ...item, isCheck: !item.isCheck } : { ...item, isCheck: false }
    )
    setPaymentObjectives(updateCheckState)
  }

  const getObjectiveValueByName = (checkboxName: string): string | number | undefined => {
    // const  = paymentObjectives.map(item =>
    //   item.name === checkboxName ? { ...item, isCheck: !item.isCheck } : item
    // )
    const paymentObjective = paymentObjectives.filter(item => {
      return item.name === checkboxName
    })
    console.log(paymentObjective[0].amount)
    return paymentObjective[0].amount > 0 ? paymentObjective[0].amount : ''
  }

  const clearAmountObjectiveCheckbox = (checkboxName: string) => {
    const clearAmount = paymentObjectives.map(item =>
      item.name === checkboxName ? { ...item, amount: Number(0) } : item
    )
    setPaymentObjectives(clearAmount)
  }

  const onChangeAmountObject = (event: React.ChangeEvent<HTMLInputElement>, checkbox: any) => {
    const { value } = event.target
    const amount = value.replace(/,/g, '')
    const updateAmountState = paymentObjectives.map(item =>
      item.name === checkbox ? { ...item, amount: Number(amount) } : item
    )
    setPaymentObjectives(updateAmountState)
  }

  const handlePaymentMethodCheckBox = (
    paymentDetail: DocumentDetailModel[],
    checkboxName: string
  ) => {
    const selectCheckbox = paymentDetail.filter(i => {
      return i.paymentMethod.name == checkboxName
    })

    // const updateCheckState = paymentDetail.map(item => {
    //   if (item.paymentMethod.name === checkboxName) {
    //     //if (item.paymentMethod.id == 4) other_pay_isCheck = !item.isCheck
    //     return { ...item, isCheck: !item.isCheck }
    //   }
    // })
  }

  const handleCheckDetail = (checkboxName: string) => {
    // let other_pay_isCheck = false
    // debugger
    // const updateCheckState = paymentDetail.map(item => {
    //   if (item.paymentMethod.name === checkboxName) {
    //     if (item.paymentMethod.id == 4) other_pay_isCheck = !item.isCheck
    //     return { ...item, isCheck: !item.isCheck }
    //   } else if (item.paymentMethod.id > 4) {
    //     if (!other_pay_isCheck) {
    //       other_pay_isCheck = paymentDetail.filter(i => {
    //         return i.paymentMethod.id == 4
    //       })[0].isCheck as boolean
    //     }

    //     if (!other_pay_isCheck) return { ...item, isCheck: false }
    //     else return { ...item, isCheck: item.isCheck }
    //   } else {
    //     return item
    //   }
    // })
    const updateCheckState = handleCheckPaymentDetail(paymentDetail, checkboxName)
    setPaymentDetail(updateCheckState)
  }

  const handleClearCheckDetail = (id: number, status: boolean) => {
    const updateCheckState = paymentDetail.map(item =>
      item.paymentMethod.id === id
        ? { ...item, isCheck: status }
        : item.paymentMethod.id > 4
        ? { ...item, isCheck: false }
        : item
    )
    setPaymentDetail(updateCheckState)
    console.log('updateCheckState', updateCheckState)
  }

  // const getPaymentDetailAmount = (checkboxName: string) => {
  //   const payAmount = paymentDetail.filter(data => {
  //     return data.paymentMethod.name === checkboxName
  //   })[0]

  //   return payAmount.paymentAmount > 0 ? payAmount.paymentAmount : ''
  // }

  // const getPaymentDetailValue = (checkboxName: string, dataKey: string): any => {
  //   const payAmount = paymentDetail.filter(data => {
  //     return data.paymentMethod.name === checkboxName
  //   })[0]

  //   switch (dataKey) {
  //     case 'cheque_Bank':
  //       return payAmount.cheque_Bank
  //     case 'cheque_Branch':
  //       return payAmount.cheque_Branch
  //     case 'cheque_Number':
  //       return payAmount.cheque_Number
  //     case 'cheque_Date':
  //       return payAmount.cheque_Date
  //     case 'creditCard_HolderName':
  //       return payAmount.creditCard_HolderName
  //     case 'creditCard_Type':
  //       return payAmount.creditCard_Type
  //     case 'creditCard_Number':
  //       return payAmount.creditCard_Number
  //     case 'creditCard_ExpDate':
  //       return payAmount.creditCard_ExpDate
  //     case 'other_Pay':
  //       return payAmount.other_Pay
  //     default:
  //       return ''
  //   }
  // }

  const clearAmountDetailCheckbox = (checkboxName: string) => {
    const clearAmount = paymentDetail.map(item =>
      item.paymentMethod.name === checkboxName
        ? {
            ...item,
            paymentAmount: Number(0)
          }
        : item
    )
    setPaymentDetail(clearAmount)
  }

  const onChangeAmountDetail = (
    event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> | any,
    checkbox: any
  ) => {
    const { value } = event.target
    const updateAmountState = paymentDetail.map(item => {
      if (item.paymentMethod.name === checkbox) {
        item.cheque_BankCode =
          event.target.name === 'cheque_Bank' ? event.value : item.cheque_BankCode
        item.creditCard_Type_dcr =
          event.target.name === 'creditCard_Type' ? event.value : item.creditCard_Type
        item.payInToBank = event.target.name === 'accountNo' ? event.payInToBank : item.payInToBank
        if (['paymentAmount', 'paymentTotalAmount'].includes(event.target.name)) {
          item = { ...item, [event.target.name]: Number(value.replace(/,/g, '')) }
        } else if (event.target.name === 'creditCard_ExpDate') {
          if (!validateMonthCreditCard(value)) {
            setFormErrors({ ...formErrors, creditCard_ExpDate: 'กรุณาตรวจสอบวันหมดอายุบัตร' })
          } else {
            setFormErrors({ ...formErrors, creditCard_ExpDate: '' })
          }

          item = { ...item, [event.target.name]: value }
        } else {
          item = { ...item, [event.target.name]: value }
        }
      }

      return item
    })
    console.log('updateAmountState1', updateAmountState)
    setPaymentDetail(updateAmountState)
  }

  const handlePayInDateChangeAmountDetail = (
    christDate: any,
    buddhistDate: any,
    paymentMethodID: number
  ) => {
    // console.log(christDate)
    // console.log(buddhistDate)

    const updateAmountState = paymentDetail.map(item => {
      if (paymentMethodID === item.paymentMethod.id) return { ...item, payInDate: christDate }
      return item
    })
    setPaymentDetail(updateAmountState)
  }

  const handleWatDatePickerChangeAmountDetail = (
    christDate: any,
    buddhistDate: any,
    paymentMethodID: number
  ) => {
    // console.log(christDate)
    // console.log(buddhistDate)
    const updateAmountState = paymentDetail.map(item => {
      if (paymentMethodID === item.paymentMethod.id) return { ...item, cheque_Date: christDate }
      return item
    })

    setPaymentDetail(updateAmountState)
    //console.log('handleWatDatePickerChangeAmountDetail', updateAmountState)
  }

  const checkHasChangeEmailOrMobile = (submitData: DocumentModel) => {
    if (!policyInfo.autoDisplay) {
      return false
    }

    return (
      submitData.customerMailCore !== submitData.customerMail ||
      submitData.customerPhoneCore !== submitData.customerPhone
    )
  }

  const getCustomerMailorPhone = ({ type = 'email' }) => {
    if (loginState.account?.agentInfo.isBranchStaff && type === 'email') {
      return policyInfo.customerMail
    }

    if (loginState.account?.agentInfo.isBranchStaff && type === 'phone') {
      return policyInfo.customerPhone
    }

    if (type === 'email') {
      return policyInfo.autoDisplay ? policyInfo.saveCustomerMail : policyInfo.customerMail
    }

    return policyInfo.autoDisplay ? policyInfo.saveCustomerPhone : policyInfo.customerPhone
  }

  const onSubmit = async (sendType: string) => {
    try {
      const date = new Date()
      const submitInfo: DocumentModel = {
        receiptNo: '',
        agentName: loginState.account?.agentInfo.name,
        branchCode: loginState.account?.agentInfo.branchCode,
        branchName: loginState.account?.agentInfo.branchName,
        payerName: policyInfo.payerName,
        insuredName: policyInfo.insuredName,
        policyNo: policyInfo.policyNo.replace(' ', '').replace('\t', ''),
        planName: policyInfo.planName,
        sumAssured: policyInfo.sumassuredAmount,
        status: 'New_ETR',
        emailstatus: +(sendType === MESSAGE_TYPE.EMAIL),
        SMSstatus: +(sendType === MESSAGE_TYPE.SMS),
        referenceId: '',
        remark: '',
        paymentFrequency: policyInfo.paymentFrequency,
        customerDOB: policyInfo.customerDOB,
        customerMail: getCustomerMailorPhone({ type: 'email' }),
        customerPhone: getCustomerMailorPhone({ type: 'phone' }),
        customerMailCore: policyInfo.autoDisplay ? policyInfo.saveCustomerMail : null,
        customerPhoneCore: policyInfo.autoDisplay ? policyInfo.saveCustomerPhone : null,
        agent: agentInfo,
        documentDetails: paymentDetail.filter(
          item => item.isCheck === true && item.paymentMethod.id != 4
        ),
        paymentObjectives: paymentObjectives.filter(item => item.isCheck === true),
        createBy: loginState.account?.agentInfo.agentId,
        updateBy: loginState.account?.agentInfo.agentId,
        serviceAgent: policyInfo.serviceAgent,
        productGroup: policyInfo.productGroup,
        SystemName: policyInfo.SystemName,
        etrStatusDate: new Date(
          Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes()
          )
        )
      }
      submitInfo.hasChangeEmailOrMobile = checkHasChangeEmailOrMobile(submitInfo)
      console.log('submitInfo', submitInfo)
      await dispatch(editActions.createTransaction(submitInfo, sendType))

      if (sendType === MESSAGE_TYPE.EMAIL) {
        navigate('/summary', {
          state: {
            message: `ส่งใบรับเงินชั่วคราวไปที่<br/>
            <b>${policyInfo.customerMail}</b><br/>
            เรียบร้อยแล้ว`,
            icon: doneCreate
          }
        })
      } else if (sendType === MESSAGE_TYPE.SMS) {
        navigate('/summary', {
          state: {
            message: `ส่งใบรับเงินชั่วคราวไปที่<br/>
            <b>${policyInfo.customerPhone}</b><br/>
            เรียบร้อยแล้ว`,
            icon: doneCreate
          }
        })
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsOpenEmailModal(false)
      setIsOpenSMSModal(false)
    }
  }

  const onDisplayDetail = () => {
    if (validateField()) {
      const submitInfo: DocumentModel = {
        receiptNo: '',
        agentName: loginState.account?.agentInfo.name,
        payerName: policyInfo.payerName,
        insuredName: policyInfo.insuredName,
        policyNo: policyInfo.policyNo.replace(' ', '').replace('\t', ''),
        planName: policyInfo.planName,
        sumAssured: policyInfo.sumassuredAmount,
        status: 'New_ETR',
        emailstatus: 0,
        SMSstatus: 0,
        referenceId: '',
        remark: '',
        paymentFrequency: policyInfo.paymentFrequency,
        customerDOB: policyInfo.customerDOB,
        customerMail: policyInfo.autoDisplay
          ? policyInfo.saveCustomerMail
          : policyInfo.customerMail,
        customerPhone: policyInfo.autoDisplay
          ? policyInfo.saveCustomerPhone
          : policyInfo.customerPhone,
        agent: agentInfo,
        documentDetails: paymentDetail
          .filter(item => item.isCheck === true && item.paymentMethod.id != 4)
          .map(item => {
            item.creditCard_Type_dcr = item.creditCard_Type
            return item
          }),
        paymentObjectives: paymentObjectives.filter(item => item.isCheck === true),
        createBy: loginState.account?.agentInfo.agentId,
        updateBy: loginState.account?.agentInfo.agentId
      }
      console.log('onDisplayDetail', submitInfo)
      setDocumentData(submitInfo)
      setDisplayDetail(true)
      window.scrollTo(0, 0)
    } else {
      window.scrollTo(0, 0)
    }
  }

  const handleHideDetail = () => {
    setDisplayDetail(false)
  }

  /* #region Email */

  const handleModalEmail = () => {
    if (validateField()) {
      if (policyInfo.autoDisplay) {
        setPolicyInfo({
          ...policyInfo,
          customerMail: policyInfo.displaycustomerMail
        })
      }

      setIsOpenEmailModal(!isOpenEmailModal)
    } else {
      window.scrollTo(0, 0)
    }
  }

  const handleEmailOk = () => {
    return onSubmit(MESSAGE_TYPE.EMAIL)
  }
  /* #endregion Email */
  /* #region SMS */
  const handleModalSMS = () => {
    if (validateField()) {
      if (policyInfo.autoDisplay) {
        setPolicyInfo({
          ...policyInfo,
          customerPhone: policyInfo.displaycustomerPhone
        })
      }
      setIsOpenSMSModal(!isOpenSMSModal)
    } else {
      window.scrollTo(0, 0)
    }
  }

  const handleSMSOk = () => {
    return onSubmit(MESSAGE_TYPE.SMS)
  }
  /* #endregion SMS */

  /* #region Search */
  const handleOpenSearchPolicyDialog = (data: any) => {
    const a = 0
    dispatch(policyDetailActions.resetData())
    setisOpenSearchModal(true)
  }

  const handleSearchPolicyOk = (data: any) => {
    console.log(data)
    setPolicyInfo({
      ...policyInfo,
      insuredName: `${data.FirstName} ${data.LastName}`,
      payerName: `${data.P_FirstName} ${data.P_LastName}`,
      policyNo: data.PolicyNo,
      paymentFrequency: isMaskingData(
        loginState.account?.agentInfo as AgentModel,
        data.AgentNumber,
        loginState.account?.agentInfo.AgentUnderAOs
      )
        ? ''
        : getBillingFrequency(data.BillingFrequency),
      planName: !isMaskingData(
        loginState.account?.agentInfo as AgentModel,
        data.AgentNumber,
        loginState.account?.agentInfo.AgentUnderAOs
      )
        ? data.PlanDescription
        : '',
      sumassuredAmount: !isMaskingData(
        loginState.account?.agentInfo as AgentModel,
        data.AgentNumber,
        loginState.account?.agentInfo.AgentUnderAOs
      )
        ? data.SumAssured
        : 0,
      customerMail: data.EmailAddress,
      customerPhone: data.MobileNo,
      customerDOB: data.DateofBirth,
      displaycustomerMail: !isMaskingData(
        loginState.account?.agentInfo as AgentModel,
        data.AgentNumber,
        loginState.account?.agentInfo.AgentUnderAOs
      )
        ? data.EmailAddress
        : maskingEmail(data.EmailAddress as string),
      displaycustomerPhone: !isMaskingData(
        loginState.account?.agentInfo as AgentModel,
        data.AgentNumber,
        loginState.account?.agentInfo.AgentUnderAOs
      )
        ? data.MobileNo
        : maskingMobileNo(data.MobileNo),
      autoDisplay: true,
      saveCustomerMail: data.EmailAddress,
      saveCustomerPhone: data.MobileNo,
      isServiceAgent: data.isServiceAgent,
      serviceAgent: data.AgentNumber,
      productGroup: data.ProductGroup,
      SystemName: data.SystemName
    })
    console.log('handleSearchPolicyOk')
    console.log(policyInfo)
    setisOpenSearchModal(!isOpenSearchModal)
  }

  const handleSearchPolicyCancel = () => {
    const a = 0
    setisOpenSearchModal(!isOpenSearchModal)
  }
  /* #endregion Search */
  const renderInputPaymentObjective = (checkbox: any) => {
    return (
      <div className="required">
        <span className="amount-text">จำนวนเงิน(บาท)</span>
        <NumberFormat
          required
          allowNegative={false}
          thousandSeparator={true}
          prefix=""
          className={`amount-input ${formErrors[checkbox.name] && 'error-border-validate'}`}
          inputMode="decimal"
          decimalScale={2}
          onChange={(e: ChangeEvent<HTMLInputElement>) => onChangeAmountObject(e, checkbox.name)}
          value={getObjectiveValueByName(checkbox.name)}
        />
        {formErrors[checkbox.name] && (
          <div className="error-text-validate">
            <img src={errorAlert} alt="ErrorAlert" />
            กรุณากรอกข้อมูล
          </div>
        )}
      </div>
    )
  }

  const handleEnterKey = (e: React.KeyboardEvent<HTMLInputElement> | any) => {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }
  const renderInputPaymentDetail = (method: any) => {
    if (method.paymentMethod.id === 2) {
      return (
        <Cheque
          branchCode={loginState.account?.agentInfo.branchCode as string}
          paymentDetail={paymentDetail}
          paymentMethod={method.paymentMethod}
          formErrors={formErrors}
          onChangeAmountDetail={onChangeAmountDetail}
          handleEnterKey={handleEnterKey}
          handleWatDatePickerChangeAmountDetail={handleWatDatePickerChangeAmountDetail}
          handlePayInDateChangeAmountDetail={handlePayInDateChangeAmountDetail}
        ></Cheque>
      )
    }

    if (method.paymentMethod.id === 3) {
      return (
        <CreditCard
          branchCode={loginState.account?.agentInfo.branchCode as string}
          paymentDetail={paymentDetail}
          paymentMethod={method.paymentMethod}
          formErrors={formErrors}
          onChangeAmountDetail={onChangeAmountDetail}
          handleEnterKey={handleEnterKey}
          handleWatDatePickerChangeAmountDetail={handleWatDatePickerChangeAmountDetail}
          handlePayInDateChangeAmountDetail={handlePayInDateChangeAmountDetail}
        ></CreditCard>
      )
    }

    if (method.paymentMethod.id === 4) {
      const getOtherPaymentMethodTypeId = () => {
        const selOtherPay: DocumentDetailModel[] = paymentDetail.filter(
          item => item.isCheck === true && item.paymentMethod.id != 4
        )

        if (selOtherPay && selOtherPay.length > 0) return selOtherPay[0].paymentMethod.id
        return ''
      }

      return (
        <OtherPay
          branchCode={loginState.account?.agentInfo.branchCode as string}
          paymentDetail={paymentDetail}
          paymentMethod={method.paymentMethod}
          formErrors={formErrors}
          onChangeAmountDetail={onChangeAmountDetail}
          handleEnterKey={handleEnterKey}
          handleWatDatePickerChangeAmountDetail={handleWatDatePickerChangeAmountDetail}
          handlePayInDateChangeAmountDetail={handlePayInDateChangeAmountDetail}
          handleCheckDetail={handleCheckDetail}
          value={getOtherPaymentMethodTypeId()}
          handleClearCheckDetail={handleClearCheckDetail}
        ></OtherPay>
      )
    }
    // if (method.paymentMethod.id === 5) {
    //   return (
    //     <CashPayIn
    //       branchCode={loginState.account?.agentInfo.branchCode as string}
    //       paymentDetail={paymentDetail}
    //       paymentMethod={method.paymentMethod}
    //       formErrors={formErrors}
    //       onChangeAmountDetail={onChangeAmountDetail}
    //       handleEnterKey={handleEnterKey}
    //       handleWatDatePickerChangeAmountDetail={handleWatDatePickerChangeAmountDetail}
    //       handlePayInDateChangeAmountDetail={handlePayInDateChangeAmountDetail}
    //     ></CashPayIn>
    //   )
    // }
    // if (method.paymentMethod.id === 6) {
    //   return (
    //     <ChequePayIn
    //       branchCode={loginState.account?.agentInfo.branchCode as string}
    //       paymentDetail={paymentDetail}
    //       paymentMethod={method.paymentMethod}
    //       formErrors={formErrors}
    //       onChangeAmountDetail={onChangeAmountDetail}
    //       handleEnterKey={handleEnterKey}
    //       handleWatDatePickerChangeAmountDetail={handleWatDatePickerChangeAmountDetail}
    //       handlePayInDateChangeAmountDetail={handlePayInDateChangeAmountDetail}
    //     ></ChequePayIn>
    //   )
    // }
    // if (method.paymentMethod.id === 7) {
    //   return (
    //     <CompanyCheque
    //       branchCode={loginState.account?.agentInfo.branchCode as string}
    //       paymentDetail={paymentDetail}
    //       paymentMethod={method.paymentMethod}
    //       formErrors={formErrors}
    //       onChangeAmountDetail={onChangeAmountDetail}
    //       handleEnterKey={handleEnterKey}
    //       handleWatDatePickerChangeAmountDetail={handleWatDatePickerChangeAmountDetail}
    //       handlePayInDateChangeAmountDetail={handlePayInDateChangeAmountDetail}
    //     ></CompanyCheque>
    //   )
    // }
    // if (method.paymentMethod.id === 8) {
    //   return (
    //     <QRCode
    //       branchCode={loginState.account?.agentInfo.branchCode as string}
    //       paymentDetail={paymentDetail}
    //       paymentMethod={method.paymentMethod}
    //       formErrors={formErrors}
    //       onChangeAmountDetail={onChangeAmountDetail}
    //       handleEnterKey={handleEnterKey}
    //       handleWatDatePickerChangeAmountDetail={handleWatDatePickerChangeAmountDetail}
    //       handlePayInDateChangeAmountDetail={handlePayInDateChangeAmountDetail}
    //     ></QRCode>
    //   )
    // }
    return (
      <div className="required">
        <span className="amount-text">เงินสด ชำระได้ไม่เกิน 100,000 บาท</span>
        <NumberFormat
          isAllowed={withValueCash}
          onKeyPress={(e: any) => handleEnterKey(e)}
          allowNegative={false}
          thousandSeparator={true}
          prefix=""
          decimalScale={2}
          name="paymentAmount"
          className={`amount-input ${formErrors.paymentAmountCash && 'error-border-validate'}`}
          inputMode="decimal"
          autoComplete="off"
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            onChangeAmountDetail(e, method.paymentMethod.name)
          }
          value={getPaymentDetailAmount(paymentDetail, method.paymentMethod.name)}
        />
        {formErrors.paymentAmountCash && (
          <div className="error-text-validate">
            <img src={errorAlert} alt="ErrorAlert" />
            กรุณากรอกข้อมูล
          </div>
        )}
      </div>
    )
  }

  const renderEtrDetail = () => {
    return (
      <>
        <EtrDetail
          documentData={documentData}
          isMasking={!policyInfo.isServiceAgent}
          isPreview={true}
        ></EtrDetail>
        <div className="group-button-entry">
          <button type="button" className="back-button" onClick={handleHideDetail}>
            ย้อนกลับ
          </button>
          <button
            type="button"
            className="confirm-button"
            onClick={handleModalEmail}
            disabled={
              policyInfo.autoDisplay &&
              !documentData.customerMail &&
              !loginState.account?.agentInfo.isBranchStaff
            }
          >
            ส่ง Email
          </button>
          <button
            type="button"
            className="confirm-button"
            onClick={() => handleModalSMS()}
            disabled={
              policyInfo.autoDisplay &&
              !documentData.customerPhone &&
              !loginState.account?.agentInfo.isBranchStaff
            }
          >
            ส่ง SMS
          </button>
        </div>
      </>
    )
  }

  const renderEntryFom = () => {
    return (
      <form
        className="container-form"
        onSubmit={e => {
          e.preventDefault()
        }}
      >
        <div>
          <div className="header-title-form">ข้อมูลตัวแทน</div>
          <form
            className="group-form"
            autoComplete="off"
            onSubmit={e => {
              e.preventDefault()
            }}
          >
            <label className="group-label-input">
              ชื่อ-นามสกุล
              <input
                className="field-input"
                type="text"
                name="name"
                value={agentInfo?.name}
                // onChange={onChangeAgentInfo}
                disabled
              />
            </label>
            <label className="group-label-input">
              รหัสตัวแทน
              <input
                className="field-input"
                type="text"
                name="agentId"
                value={agentInfo?.agentId}
                onChange={onChangeAgentInfo}
                disabled
              />
            </label>
            {/* <label className="group-label-input required">
          <span>หน่วย</span>
          <input
            required
            className={`field-input ${formErrors.unitName && 'error-border-validate'}`}
            type="text"
            name="unitName"
            value={agentInfo?.unitName}
            onChange={onChangeAgentInfo}
          />
          {formErrors.unitName && (
            <div className="error-text-validate">
              <img src={errorAlert} alt="ErrorAlert" />
              กรุณากรอกข้อมูล
            </div>
          )}
        </label> */}
            <label className="group-label-input">
              <span>สาขา</span>
              <BranchList
                agentData={loginState.account?.agentInfo as AgentModel}
                onChange={e => onChangeAgentInfo(e)}
              />
              {formErrors.branchName && (
                <div className="error-text-validate">
                  <img src={errorAlert} alt="ErrorAlert" />
                  กรุณากรอกข้อมูล
                </div>
              )}
            </label>
            <label className="group-label-input">
              <span>อีเมลตัวแทน</span>
              <input
                disabled
                required
                pattern="^[A-Za-z]"
                className={`field-input ${formErrors.email && 'error-border-validate'}`}
                type="email"
                name="email"
                value={agentInfo?.email}
                onChange={onChangeAgentInfo}
                autoComplete="off"
              />
              {formErrors.email && (
                <div className="error-text-validate">
                  <img src={errorAlert} alt="ErrorAlert" />
                  กรุณากรอกข้อมูล
                </div>
              )}
            </label>
          </form>
        </div>

        <div>
          <div className="header-title-form">
            <div> ข้อมูลกรมธรรม์</div>
            <div>
              <button
                type="button"
                className="open-search-policy-button"
                onClick={handleOpenSearchPolicyDialog}
              >
                <svg
                  width="8"
                  height="12"
                  viewBox="0 0 8 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.243621 5.87798C-0.0812071 5.57093 -0.0812071 5.07227 0.243621 4.76523L0.440745 4.57891L3.38363 7.35808V0.75H4.49415V7.35548L7.43427 4.57628L7.63138 4.76263C7.95621 5.06968 7.95621 5.5683 7.63138 5.87535L3.94167 9.36308L0.243621 5.87798ZM7.52866 10.2003H0.346343C0.193646 10.2003 0.0687123 10.3184 0.0687123 10.4627V10.9876C0.0687123 11.1319 0.193646 11.25 0.346343 11.25H7.52866C7.68135 11.25 7.80629 11.1319 7.80629 10.9876V10.4627C7.80629 10.3184 7.68135 10.2003 7.52866 10.2003Z"
                    fill="white"
                  />
                </svg>
                <span>ค้นหาข้อมูลลูกค้า</span>
              </button>
            </div>
          </div>
          <form
            className="group-form"
            onSubmit={e => {
              e.preventDefault()
            }}
          >
            <label className="group-label-input required">
              <span>ชื่อ-สกุล ผู้ชำระเบี้ย</span>
              <input
                required
                // disabled={policyInfo.autoDisplay}
                className={`field-input ${formErrors.payerName && 'error-border-validate'} `}
                autoComplete="off"
                type="text"
                name="payerName"
                value={policyInfo.payerName}
                onChange={onChangePolicyInfo}
                maxLength={30}
              />
              {formErrors.payerName && (
                <div className="error-text-validate">
                  <img src={errorAlert} alt="ErrorAlert" />
                  กรุณากรอกข้อมูล
                </div>
              )}
            </label>
            <label className="group-label-input required">
              <span>ชื่อ-สกุล ผู้เอาประกันภัย</span>
              <input
                required
                disabled={policyInfo.autoDisplay}
                className={`field-input ${formErrors.insuredName && 'error-border-validate'}`}
                autoComplete="off"
                type="text"
                name="insuredName"
                value={policyInfo.insuredName}
                onChange={onChangePolicyInfo}
                maxLength={30}
              />
              {formErrors.insuredName && (
                <div className="error-text-validate">
                  <img src={errorAlert} alt="ErrorAlert" />
                  กรุณากรอกข้อมูล
                </div>
              )}
            </label>

            <label className={`group-label-input ${checkNonNBCase() && 'required'}`}>
              <span>เลขที่กรมธรรม์</span>
              <input
                required
                disabled={policyInfo.autoDisplay}
                className={`field-input ${formErrors.policyNo && 'error-border-validate'}`}
                autoComplete="off"
                type="text"
                name="policyNo"
                value={policyInfo.policyNo}
                onChange={onChangePolicyInfo}
              />
              {formErrors.policyNo && (
                <div className="error-text-validate">
                  <img src={errorAlert} alt="ErrorAlert" />
                  กรุณากรอกข้อมูล
                </div>
              )}
            </label>

            <label className="group-label-input">
              แบบประกันภัย
              <input
                disabled={policyInfo.autoDisplay}
                className="field-input"
                autoComplete="off"
                type="text"
                name="planName"
                onChange={onChangePolicyInfo}
                value={policyInfo.planName}
              />
            </label>

            <label className="group-label-input">
              จำนวนเงินเอาประกันภัย (บาท)
              <NumberFormat
                disabled={policyInfo.autoDisplay}
                allowNegative={false}
                thousandSeparator={true}
                prefix=""
                name="sumassuredAmount"
                className="amount-input"
                inputMode="decimal"
                onChange={onChangePolicyInfo}
                autoComplete="off"
                decimalScale={0}
                value={policyInfo.sumassuredAmount > 0 ? policyInfo.sumassuredAmount : undefined}
              />
            </label>

            <label className="group-label-input">
              งวดการชำระราย
              <select
                className="field-input"
                name="paymentFrequency"
                placeholder="งวดการชำระ"
                onChange={e => onChangePolicyInfo(e)}
                value={policyInfo.paymentFrequency}
              >
                <option value="">เลือก</option>
                <option value="ปี">ปี</option>
                <option value="6 เดือน">6 เดือน</option>
                <option value="3 เดือน">3 เดือน</option>
                <option value="เดือน">เดือน</option>
                <option value="ชำระครั้งเดียว">ชำระครั้งเดียว</option>
              </select>
            </label>
          </form>
        </div>

        <div>
          <div className="header-title-form">รายการการรับเงินค่าเบี้ยประกันภัย และอื่นๆ</div>
          <div className="object-title-form ">เพื่อชำระ</div>
          <div className="container-checkbox">
            {paymentObjectives.map(item => {
              return (
                <li
                  key={item.name}
                  className={
                    isDisablePaymentObject(item.name, policyInfo.autoDisplay) ? 'disabled' : ''
                  }
                >
                  <label className="group-checkbox-label">
                    <input
                      disabled={isDisablePaymentObject(item.name, policyInfo.autoDisplay)}
                      type="radio"
                      checked={item.isCheck}
                      onChange={() => handleCheckObjective(item.name)}
                      onBlur={() => clearAmountObjectiveCheckbox(item.name)}
                    />
                    {item.paymentObjectiveType.name}
                  </label>
                  {item.isCheck && renderInputPaymentObjective(item)}
                </li>
              )
            })}
          </div>

          <div className="total-payment-objective">
            <div>รวมเบี้ยทั้งหมด(บาท)</div>
            <div>
              <NumberFormat
                value={calPaymentObjective()}
                displayType="text"
                decimalScale={2}
                thousandSeparator={true}
                prefix=""
                fixedDecimalScale
              />
            </div>
          </div>

          <div className="object-title-form ">ชำระโดย</div>
          <div className="container-checkbox">
            {paymentDetail
              .filter(p => p.paymentMethod.isActive === true)
              .map(item => {
                return (
                  <li
                    key={item.paymentMethod.id}
                    style={{
                      display: hideCashPayment(
                        item.paymentMethod.id,
                        policyInfo.policyNo,
                        policyInfo.productGroup
                      )
                    }}
                  >
                    <label
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: 'fit-content'
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={item.isCheck}
                        onChange={() => handleCheckDetail(item.paymentMethod.name)}
                        onBlur={() => clearAmountDetailCheckbox(item.paymentMethod.name)}
                      />
                      {item.paymentMethod.description}
                    </label>
                    {item.isCheck && renderInputPaymentDetail(item)}
                  </li>
                )
              })}
          </div>

          <div style={{ marginBottom: 52 }}>
            <div className="total-payment-objective">
              <div>รวมเบี้ยชำระทั้งหมด(บาท)</div>
              <div>
                <NumberFormat
                  value={calPaymentDetail()}
                  displayType="text"
                  thousandSeparator={true}
                  prefix=""
                  decimalScale={2}
                  fixedDecimalScale
                />
              </div>
            </div>
            {formErrors.amount && (
              <div className="error-amount-validate">
                <img src={errorAlert} alt="ErrorAlert" />
                <span>กรุณาระบุจำนวน'เบี้ยชำระทั้งหมด'ให้ตรงกับ'จำนวนเบี้ยรวมทั้งหมด'</span>
              </div>
            )}
          </div>
        </div>

        <div className="group-button-detail">
          <button type="button" className="confirm-button" onClick={onDisplayDetail}>
            เรียกดูใบรับเงินชั่วคราว
          </button>
        </div>
      </form>
    )
  }

  return (
    <div>
      <HeaderBar>
        <div className="header-bar-text">ใบรับเงินชั่วคราว</div>
      </HeaderBar>

      <div className="container container-entry">
        {!displayDetail && renderEntryFom()}
        {displayDetail && renderEtrDetail()}
      </div>
      <div>
        <EmailModal
          handleOkButton={handleEmailOk}
          handleCancelbutton={handleModalEmail}
          handelModalDataChange={onChangePolicyInfo}
          handleWatDatePickerChange={handleWatDatePickerChange}
          isOpenModal={isOpenEmailModal}
          policyInfo={policyInfo}
        ></EmailModal>
        <SMSModal
          handleOkButton={handleSMSOk}
          handleCancelbutton={handleModalSMS}
          handelModalDataChange={onChangePolicyInfo}
          handleWatDatePickerChange={handleWatDatePickerChange}
          isOpenModal={isOpenSMSModal}
          policyInfo={policyInfo}
        ></SMSModal>
        <SearchPolicyModal
          handleOkButton={handleSearchPolicyOk}
          handleCancelbutton={handleSearchPolicyCancel}
          isOpenModal={isOpenSearchModal}
          data={''}
        ></SearchPolicyModal>
      </div>
    </div>
  )
}
